import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CategoryForm from '@/components/categories/CategoryForm.vue';
import CategoryHierarchyForm from '@/components/categories/CategoryHierarchyForm.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import TranslatedState from '@/components/common/TranslatedState.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Category } from '@/models/category.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesList',
  setup(__props) {

const store = useStore<ShiftCMSState & { cs: CategoriesState }>();
const events = useEvents();
const categories = computed<Category[]>(() => store.state.cs.categories);

const addCategory = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(CategoryForm) });
};

const editCategory = (_: Event, { item }: { item: Category }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(CategoryForm),
    data: item,
  });
};

const editHierarchy = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(CategoryHierarchyForm),
    small: true,
  });
};

const update = () => {
  store.dispatch(CategoriesActions.GetCategories);
};

onMounted(() => {
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
  store.commit(Mutations.HideDrawer);
});

const headers = [
  { title: 'ID', key: 'id', width: '5%' },
  { title: 'Emoji', key: 'emoji', sortable: false, width: '5%' },
  { title: 'Title', key: 'title' },
  { title: 'Type', key: 'type' },
  { title: 'State', key: 'translated', sortable: false },
];

const filterTitle = ref<string>('');
const filterType = ref<string>('');
const filteredCategories = computed(() =>
  categories.value
    .filter((v) =>
      filterType.value === 'main'
        ? !v.parentCategory
        : filterType.value === 'sub'
        ? !!v.parentCategory
        : true,
    )
    .filter((v) =>
      filterTitle.value
        ? v.title.toLowerCase().indexOf(filterTitle.value.toLowerCase()) !== -1
        : true,
    ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterType.value = filters.filter;
  filterTitle.value = filters.filterTitle;
}

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode("Categories ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(ListFilter, {
        onFilter: updateFilter,
        options: [
        { label: 'Main', value: 'main' },
        { label: 'Sub', value: 'sub' },
      ]
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editCategory,
        headers: headers,
        items: filteredCategories.value.sort((a, b) => a.index - b.index),
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.type": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(!item.parentCategory ? 'Main category' : 'Sub category'), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createVNode(TranslatedState, { item: item }, null, 8, ["item"])
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addCategory,
        color: "success"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Add Category")
        ])),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        onClick: editHierarchy,
        color: "success",
        class: "ml-4"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Sort and Hierarchy")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})